module.exports = "/images/vendor/desiigner-svg/svg/ui/wallet.svg?814e0c02606aeac8024ac51104da4962";